import React from 'react'
import { makeStyles } from '@material-ui/core'

const WHATSAPP_NUMBER = '+5567999725550'
const WHATSAPP_MESSAGE = encodeURIComponent('Olá! Encontrei um problema no sistema Congado.')
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`

const useStyles = makeStyles(() => ({
  container: {
    padding: '16px',
    borderTop: '1px solid rgba(212, 199, 188, 0.2)',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: 6
  },
  text: {
    fontSize: 13,
    color: 'rgba(255, 255, 255, 0.6)',
    fontFamily: 'Open Sans, sans-serif',
    lineHeight: 1.4
  },
  link: {
    fontSize: 13,
    color: '#D4C7BC',
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 700,
    textDecoration: 'underline',
    '&:hover': {
      color: '#fff'
    }
  }
}))

export function useDevelopmentBanner() {
  const styles = useStyles()

  const banner = (
    <div className={styles.container}>
      <span className={styles.text}>Estamos em fase de desenvolvimento. Encontrou algum problema?</span>
      <a href={WHATSAPP_URL} target='_blank' rel='noopener noreferrer' className={styles.link}>
        Fale conosco pelo WhatsApp
      </a>
    </div>
  )

  return { banner }
}
